import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useIsMount } from "../hooks/useIsMount.js";
import { useDispatch } from "react-redux";

export default function RouterChanges() {
  const { pathname } = useLocation();
  const initialPath = useRef(pathname);
  const isMount = useIsMount();
  const dispatch = useDispatch();

  useEffect(() => {
    let divExists = window?.document.getElementById("main") !== null;
    if (divExists) {
      window.document.getElementById("main").style.display =
        initialPath.current === pathname ? "block" : "none";
    }
    if (!isMount) {
      dispatch({ type: "NOSSR" });

      // GA4 enhanced measurement tracks history changes, including query changes.
      // Sending an app page_view here would count the same navigation twice.
    }
  }, [pathname]);

  return null;
}
